import { CAST_AI } from '@cast/constants';
import {
  ToggleButton,
  ToggleButtonGroup,
  Stack,
  tokens,
} from '@cast/design-system';

import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { RffCodeEditor } from '@cast/shared-rff-ui';

export const InitScriptSection = ({
  isReadOnly,
  initScriptType,
  setInitScriptType,
}: {
  isReadOnly: boolean;
  initScriptType: 'yaml' | 'bash';
  setInitScriptType: (type: 'yaml' | 'bash') => void;
}) => {
  return (
    <InlineWithDescription
      borderBottom="none"
      description={
        <ControlWithDescription label="Init script">
          Define the script to be run when building the node provisioned by{' '}
          {CAST_AI}. The script should not contain any sensitive data.
        </ControlWithDescription>
      }
      controls={
        <Stack gap={12} maxWidth={600} alignItems="flex-end">
          <ToggleButtonGroup
            value={initScriptType}
            disabled={isReadOnly}
            onChange={(_, value) => {
              if (value) {
                setInitScriptType(value);
              }
            }}
            size="sm"
          >
            <ToggleButton
              testId="init-script-type-yaml"
              value="yaml"
              text="Yaml"
            />
            <ToggleButton
              testId="init-script-type-bash"
              value="bash"
              text="Bash"
            />
          </ToggleButtonGroup>
          <RffCodeEditor
            testId="init-script-editor"
            name="initScript"
            highlight={initScriptType}
            placeholder={
              initScriptType === 'yaml'
                ? '#cloud-config\nmerge_how:\n  - name: list\n    settings: [prepend]\nbootcmd:\n  - echo "configuring boot"'
                : '#!/bin/bash\n\necho "enter your script"'
            }
            sx={{
              minHeight: '140px',
              maxHeight: '280px',
              width: '100%',
              overflow: 'auto',
              '& .CodeEditor-editor': {
                backgroundColor: tokens.theme.bg.structural.code,
              },
            }}
          />
        </Stack>
      }
    />
  );
};
